import React, { useState, useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import SigninWrapper from '../../components/wrapper/SigninWrapper';
import Button from '../../components/button/Button';
import InputField from '../../components/Form/InputField';
import { useFormik } from 'formik';
import { resetPasswordSchema } from '../../schema';
import { resetPasswordAPI } from '../../API/auth/PasswordAPI';
import ButtonLoader from '../../components/button/ButtonLoader';
import toast from 'react-hot-toast';

const initialState = {
  code: "",
  password: "",
  confirmPassword: "",
};

const ResetPassword = () => {
  const [loading, setLoading] = useState(false);
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const email = searchParams.get('email');

  useEffect(() => {
    if (!email) {
      toast.error("Please request a password reset first.");
      navigate('/forgetPassword');
    }
  }, [email, navigate]);

  const { values, errors, touched, handleBlur, handleChange, handleSubmit } = useFormik({
    initialValues: initialState,
    validationSchema: resetPasswordSchema,
    onSubmit: async (values, { resetForm }) => {
      if (!email) {
        toast.error("Please request a password reset first");
        return;
      }

      setLoading(true);
      try {
        await resetPasswordAPI({
          email: email,
          code: values.code,
          password: values.password,
        });
        toast.success("Password reset successfully! You can now login with your new password.");
        resetForm();
        setTimeout(() => {
          navigate('/signin');
        }, 2000);
      } catch (err) {
        console.error(err);
        if (err.response?.data?.error?.message) {
          toast.error(err.response.data.error.message);
        } else {
          toast.error("Error resetting password. Please try again.");
        }
      } finally {
        setLoading(false);
      }
    },
  });

  if (!email) {
    return null; // Will redirect via useEffect
  }

  return (
    <>
      <SigninWrapper headingText={"Reset Your Password"}>
        <form onSubmit={handleSubmit} className="space-y-4 md:space-y-6">
          <InputField
            label={"Verification Code"}
            id={"code"}
            name={"code"}
            type={"text"}
            placeholder={"Enter 6-digit code"}
            maxLength={6}
            value={values.code}
            onChange={handleChange}
            onBlur={handleBlur}
            error={errors.code}
            touch={touched.code}
          />

          <InputField
            label={"New Password"}
            id={"password"}
            name={"password"}
            type={"password"}
            placeholder={"Enter your new password"}
            value={values.password}
            onChange={handleChange}
            onBlur={handleBlur}
            error={errors.password}
            touch={touched.password}
          />

          <InputField
            label={"Confirm New Password"}
            id={"confirmPassword"}
            name={"confirmPassword"}
            type={"password"}
            placeholder={"Confirm your new password"}
            value={values.confirmPassword}
            onChange={handleChange}
            onBlur={handleBlur}
            error={errors.confirmPassword}
            touch={touched.confirmPassword}
          />

          {loading ? (
            <div className="flex justify-center items-center">
              <ButtonLoader />
            </div>
          ) : (
            <Button type={"submit"} text={"Reset Password"} />
          )}
        </form>
      </SigninWrapper>
    </>
  );
};

export default ResetPassword;

